import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { galleryAPI } from '../api';
import { Card } from '../components/ui/card';
import { useSettings } from '../contexts/SettingsContext';

const Gallery = () => {
  const { settings } = useSettings();
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    loadGallery();
  }, [selectedCategory]);

  // Update title on mount
  useEffect(() => {
    document.title = `Galeri - ${settings.site_name || 'Cinefora'}`;
  }, [settings.site_name]);

  const loadGallery = async () => {
    try {
      const response = await galleryAPI.getAll(selectedCategory === 'all' ? null : selectedCategory);
      setGallery(response.data);
    } catch (error) {
      console.error('Error loading gallery:', error);
    } finally {
      setLoading(false);
    }
  };

  const categories = ['all', ...new Set(gallery.map(item => item.category))];

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Helmet>
        <title>Galeri - {settings.site_name || 'Cinefora'}</title>
        <meta name="description" content="Cinefora galeri - Sinema etkinliklerinden ve filmlerden kareler. Vizyondaki filmler ve sinema atmosferinden görseller." />
        <meta name="keywords" content="galeri, sinema galeri, film görselleri, cinefora" />
      </Helmet>
      <Header />
      <div className="container mx-auto px-6 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">Galeri</h1>
        
        <div className="flex gap-3 mb-8 flex-wrap">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full font-semibold transition-colors ${
                selectedCategory === category
                  ? 'bg-[#FDB714] text-black'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              {category === 'all' ? 'Tümü' : category}
            </button>
          ))}
        </div>
        
        {loading ? (
          <p className="text-white text-center">Yükleniyor...</p>
        ) : gallery.length === 0 ? (
          <p className="text-gray-400 text-center">Henüz galeri içeriği bulunmamaktadır.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {gallery.map((item) => (
              <Card key={item._id} className="bg-gray-900 border-gray-800 overflow-hidden group">
                <div className="relative overflow-hidden aspect-square">
                  <img 
                    src={item.image} 
                    alt={item.title} 
                    className="w-full h-full object-cover transition-transform group-hover:scale-110 duration-300" 
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-white font-bold">{item.title}</h3>
                  <p className="text-gray-500 text-sm">{item.category}</p>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Gallery;
